import * as angular from 'angular';
import * as _ from 'lodash';

import { ITicketStatusService } from '../../services';
import { TicketStatus } from '../../models';
import { Store } from '../Store';
import * as TICKETSTATUSES from './ticketStatuses.constants';

import {
    loadTicketStatuses,
    loadTicketStatusesSuccess,
} from './ticketStatuses.actions';


export interface ITicketStatusActionsService {
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<TicketStatus[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<TicketStatus[]>;
}

export class TicketStatusActionsService implements ITicketStatusActionsService {

    static serviceId = 'ticketStatusActionsService';
    static $inject = ['$q', 'ticketStatusService'];


    constructor(private _$q: angular.IQService,
        private _ticketStatuseService: ITicketStatusService) {
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { ticketStatuses } = getState();
            if (force || (!ticketStatuses.isLoading && !ticketStatuses.isLoaded)) {
                dispatch(loadTicketStatuses());
                return this._ticketStatuseService.getAll(force)
                    .then(data => {
                        dispatch(loadTicketStatusesSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: TICKETSTATUSES.TICKET_STATUSES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<TicketStatus>(ticketStatuses.dictionary));
            }
        };
    }
}